


import 'controllers'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import "../scss/datepicker"


document.addEventListener("DOMContentLoaded",
function(){
    // Datepickers exclusivos para el formulario de TOURS
    flatpickr('.tours-checkin', {
        disableMobile: "true",
        theme: 'dark',
        minDate: 'today',
        dateFormat: 'j',
        onChange: function(selectedDates, dateStr, instance) {
            instance.close();
        }
    });

    flatpickr('.tours-checkout', {
        disableMobile: "true",
        theme: 'dark',
        minDate: 'today',
        dateFormat: 'j',
        onChange: function(selectedDates, dateStr, instance) {
            instance.close();
        }
    });

    flatpickr('.datepicker-tour', {
        disableMobile: "true",
        theme: 'dark',
        minDate: 'today',
        dateFormat: 'j',
        onChange: function(selectedDates, dateStr, instance) {
            instance.close();
        }
    });

    var from = flatpickr(".datepicker-from", {
        disableMobile: "true",
        theme: 'dark',
        minDate:'today',
        dateFormat:'j',
       // disable: [
         //   function(date) {
                // disable every multiple of 8
        //     return ( date.getDay() === 5 || date.getDay() === 0 || date.getDay() === 1 || date.getDay() === 2 || date.getDay() === 3 || date.getDay() === 4   || date.getFullYear() === 2022);
        //  }
        //],
        onDayCreate: function(dObj, dStr, fp, dayElem){
            // Utilize dayElem.dateObj, which is the corresponding Date
            var date = dayElem.dateObj;
            $('.date_checkin').val(date)
            var day = date.getDay();
            switch(day){
                case 6:
                    dayElem.innerHTML += "<span class='event'></span>";
                break;
                default:

            }

        },
        onChange: function(selectedDates, dateStr, instance) {
            var selDate = new Date(selectedDates);
            $('.date_checkin').val(selDate);
            var month= selDate.toLocaleString('en-EN', { month: 'short' })
            var year = selDate.getUTCFullYear();
            var month_year_in= month+" "+year
            $('.checkin-text').text(month_year_in)

            var endDay = selDate.setDate(selDate.getDate() + parseInt(1));
            $('.date_checkout').val(endDay);
            //instance.config.maxDate = endDay ;
            till.set('minDate',selDate)
            //till.set('maxDate',selDate)
            till.setDate(endDay)
            var month= selDate.toLocaleString('en-EN', { month: 'short' })
            var year = selDate.getUTCFullYear();
            var month_year_out= month+" "+year
            $('.checkout-text').text(month_year_out)

            instance.close();
            till.open();
            till.close();
            //instance.config.setMaxDate('maxDate',endDay);
            //console.log(instance.config);




        },
    });



    var till = flatpickr(".datepicker-till", {
        disableMobile: "true",
        theme: 'dark',
        dateFormat:'j',
        // disable: [
         //    function(date) {
                // disable every multiple of 8
         //        return ( date.getDay() === 0 || date.getDay() === 1 || date.getDay() === 2 || date.getDay() === 3 || date.getDay() === 5 || date.getDay() === 6 || date.getDay() === 7 || date.getFullYear() === 2021 );
         //    }
        // ],
        onDayCreate: function(dObj, dStr, fp, dayElem){
            // Utilize dayElem.dateObj, which is the corresponding Date
            var date = dayElem.dateObj;
            $('.date_checkout').val(dObj)
            var day = date.getDay();
            switch(day){
                case 6:
                    dayElem.innerHTML += "<span class='event'></span>";
                break;
                default:
            }

        },
        onChange: function(selectedDates, dateStr, instance) {
            var selDate = new Date(selectedDates);
            $('.date_checkout').val(selDate);
            var month= selDate.toLocaleString('en-EN', { month: 'short' })
            var year = selDate.getUTCFullYear();
            var month_year_out= month+" "+year
            $('.checkout-text').text(month_year_out)
            var endDay = selDate.setDate(selDate.getDate() + parseInt(5));
            instance.jumpToDate(endDay,true)


        },
    });

    var today = new Date();
    var month= today.toLocaleString('en-EN', { month: 'short' })
    var year = today.getUTCFullYear();
    var month_year_in= month+" "+year
    $('.checkin-text').text(month_year_in)


    var nextSaturday = dates(today, 1)
    var nextTillDefault = addDays(today, 1);

    var month= nextTillDefault.toLocaleString('en-EN', { month: 'short' })
    var year = nextTillDefault.getUTCFullYear();
    var month_year_out= month+" "+year
    $('.checkout-text').text(month_year_out)
    from.setDate(today)
    till.setDate(nextTillDefault)
    $('.date_checkin').val(today)
    $('.date_checkout').val(nextTillDefault)
    function dates(date, dayOfWeek){
        var resultDate = new Date(date.getTime());

        resultDate.setDate(date.getDate() + (7 + dayOfWeek - date.getDay()) % 7);

        return resultDate;
    }
    function addDays(date, days) {
        const copy = new Date(Number(date))
        copy.setDate(date.getDate() + days)
        return copy
    }

})
